export const defaultClass = {
    feeChargeBasis: 0,
    enableAutoSectionChat: false,
    canDeposit: false,
    depositAmount: 0,
    className: '',
    subTitle: '',
    description: '',
    description2: '',
    capacity: 1,
    reEnrolDays: 0,
    txnDueDays: 0,
    shortDesc: '',
    newEnrolDays: 0,
    comments: '',
    termId: null,
    classTypeId: null,
    classGenderTypeId: null,
    locationId: null,
    teacherId: null,
    additionalTeacherIds: [],
    ageGroupId: null,
    validateMinimum: false,
    validateMaximum: false,
    dateStart: null,
    dateEnd: null,
    bookingStart: null,
    bookingEnd: null,
    termStart: null,
    termEnd: null,
    createdBy: '',
    registerCode: '',
}
